const getters = {
  subjectObj: (state) => state.subjectObj,
  categoryObj: (state) => state.categoryObj,
  courseInformation: (state) => state.courseInformation,
  questionsBasket: (state) => state.questionsBasket,
  knowledgeName: (state) => state.questionsBasket.map((item) => {
    if (item.knowledge && item.knowledge.length > 0) {
      return item.knowledge;
    } if (item.knowledge_codes && item.knowledge_codes.length > 0) {
      return item.knowledge_codes;
    }
    return item.title_question.knowledge;
  }).reduce((pre,
    cur) => [...pre, ...cur.map((item) => item.tag_name)], []), // 知识点名称
  knowledgeCode: (state) => state.questionsBasket.map((item) => {
    if (item.knowledge && item.knowledge.length > 0) {
      return item.knowledge;
    } if (item.knowledge_codes && item.knowledge_codes.length > 0) {
      return item.knowledge_codes;
    }
    return item.title_question.knowledge;
  }).reduce((pre,
    cur) => [...pre, ...cur.map((item) => item.tag_code)], []), // 知识点code
  singleChoiceCount: (state) => state.questionsBasket.map((item) => item.question_type === 1 && item.question_title_uuid === '')
    .reduce((pre, cur) => pre + cur, 0), // 单选题
  multipleChoiceCount: (state) => state.questionsBasket.map((item) => item.question_type === 2)
    .reduce((pre, cur) => pre + cur, 0), // 多选题
  completionCount: (state) => state.questionsBasket.map((item) => item.question_type === 3 && item.show_type !== '103')
    .reduce((pre, cur) => pre + cur, 0), // 填空题
  decideCount: (state) => state.questionsBasket.map((item) => item.question_type === 3 && item.show_type === '103')
    .reduce((pre, cur) => pre + cur, 0), // 判断题
  gapFillingCount: (state) => state.questionsBasket.map((item) => item.question_type === 6)
    .reduce((pre, cur) => pre + cur, 0), // 选词填空题
  setMembershipCount: (state) => state.questionsBasket.map((item) => item.question_title_uuid !== '')
    .reduce((pre, cur) => pre + cur, 0), // 题冒题
  atKnowledgeList: (state) => state.atKnowledgeList, // amt知识点列表
  filtrateArray: (state) => state.filtrateArray, // mt试题筛选后的数组
  selectTagArray: (state) => state.selectTagArray, // 文科筛选题目Tag
  checkedWeakPointList: (state) => state.checkedWeakPointList, // 薄弱知识点选择列表
  testInfo: (state) => state.testInfo,
  topicList: (state) => state.topicList,
  commonWrongCategoryObj: (state) => state.commonWrongCategoryObj, // 练习中心高频错题
  commonWeakCategoryObj: (state) => state.commonWeakCategoryObj, // 练习中心薄弱知识点
  commonWeakCourseInformation: (state) => state.commonWeakCourseInformation, // 练习中心薄弱知识点
  evaWrongCategoryObj: (state) => state.evaWrongCategoryObj, // 测评中心高频错题信息
  evaWeakCategoryObj: (state) => state.evaWeakCategoryObj, // 测评中心薄弱知识点信息
};
export default getters;
